<template>
  <div :class="$style.container">
    <transition @enter="enter" @leave="leave" :css="false">
      <form
        action=""
        :class="$style.form"
        v-if="!sended"
        key="form"
        data-anim="fade"
      >
        <div :class="[$style.inputContainer, status.name ? $style[status.name] : false ]">
          <p  v-if="errors.has('name')">{{ global.form.error.name }}</p>
          <input
            v-validate="'required'"
            @focus="handleFocus" type="text" name="name"
            v-model="name"
            :placeholder="global.form.placeholder.name"/>
        </div>

        <div :class="[$style.inputContainer, status.surname ? $style[status.surname] : false]">
          <p v-if="errors.has('surname')">{{ global.form.error.surname }}</p>
          <input
            v-validate="'required'"
            @focus="handleFocus"
            type="text"
            name="surname"
            v-model="surname"
            :placeholder="global.form.placeholder.surname"/>
          </div>

        <div :class="[$style.inputContainer, status.phone ? $style[status.phone] : false]">
          <p v-if="errors.has('phone')">{{ global.form.error.phone }}</p>
          <input
            @focus="handleFocus"
            type="text"
            name="phone"
            v-model="phone"
            :placeholder="global.form.placeholder.phone"/>
        </div>

        <div :class="[$style.inputContainer, status.email ? $style[status.email] : false]">
          <p v-if="errors.has('email')">{{ global.form.error.email }}</p>
          <input 
            v-validate="'required|email'"
            @focus="handleFocus" type="text" name="email" 
            v-model="email"
            :placeholder="global.form.placeholder.email"/>
        </div>

        <!-- <div :class="[$style.inputContainer, $style.fullWidth, status.position ? $style[status.position] : false]">
          <p v-if="errors.has('position')">{{ global.form.error.position }}</p>
          <input 
            v-validate="'required'"
            @focus="handleFocus" name="position"
            v-model="position"
            :placeholder="global.form.placeholder.position" />
        </div> -->

        <div :class="[$style.inputContainer, $style.fullWidth, status.message ? $style[status.message] : false]">
          <p v-if="errors.has('message')">{{ global.form.error.message }}</p>
          <textarea 
            v-validate="'required'"
            @focus="handleFocus" name="message"
            v-model="message"
            :placeholder="global.form.placeholder.message"></textarea>
        </div>

        <div :class="[$style.inputContainer, $style.fullWidth, $style.privacy, status.privacy ? $style[status.privacy] : false]">
          <p v-if="errors.has('privacy')">{{ global.form.error.privacy }}</p>
          <label for="privacy">
            <input
            v-validate="'required'"
            name="privacy"
            id="privacy"
            v-model="privacy"
            type="checkbox"
            value="1" />
            <span :class="$style.fakeInput"></span>
            <div v-html="global.form.placeholder.privacy"></div>
          </label>
        </div>

        <div :class="$style.submitContainer">
          <Cta :class="$style.submit" type="submit" @click.native="submitForm" @mouseenter.native="$hover">{{ global.submitJob }}</Cta>
        </div>
      </form>

      <div :class="$style.thxMsg" v-if="sended" key="thx">
        <p v-html="global.form.thxMsg"></p>
      </div>
    </transition>
  </div>
</template>

<script>
import gsap from 'gsap'
import { mapState } from 'vuex'
import Cta from '@/components/Cta'

export default {
  props: ['content'],

  computed: {
    ...mapState(['global'])
  },

  components: {
    Cta
  },

  data() {
    return {
      focused: false,
      name: '',
      surname: '',
      message: '',
      phone: '',
      email: '',
      privacy: '',
      status: {
        name: false,
        surname: false,
        phone: false,
        email: false,
        message: false,
        privacy: false
      },

      sended: false
    }
  },

  methods: {
    handleFocus(e) {
      if (this.focused) this.status[this.focused] = false
      this.focused = e.target.name
      this.status[e.target.name] = 'focus'
    },

    submitForm(event) {
      event.preventDefault()

      // this.$el.querySelector('.prev').style.pointerEvents = 'none'
      // this.$el.querySelector('.next').style.pointerEvents = 'none'

      this.$validator.validateAll().then((result) => {
        if (result) {
          // eslint-disable-next-line
          const createData = {
            name: this.name,
            surname: this.surname,
            email: this.email,
            phone: this.phone,
            message: this.message,
            position: this.position
          }

          this.$store.dispatch('SEND_FORM', createData).then((response) => {
            // this.$el.querySelector('.prev').style.pointerEvents = 'auto'
            // this.$el.querySelector('.next').style.pointerEvents = 'auto'

            if (response) {
              this.sended = true
            }
          })
        } else {
          // this.$el.querySelector('.prev').style.pointerEvents = 'auto'
          // this.$el.querySelector('.next').style.pointerEvents = 'auto'
        }
      })
    },

    enter(el, done) {
      gsap.to(el, 1, {
        startAt: {
          y: 100
        },
        autoAlpha: 1,
        y: 0,
        ease: gsap.Expo.easeOut,
        onComplete: done
      })
    },

    leave(el, done) {
      gsap.to(el, 1, {
        autoAlpha: 0,
        y: -200,
        ease: gsap.easeOut,
      })
    }
  }
}
</script>

<style module lang="scss">
@import "~sass-mq/mq";

.container {
  position: relative;
  overflow: hidden;
  padding: 0 0 $viewport-margin-mobile 0;
  max-width: 1280px;
  margin: 0 auto;
  padding: 25px;

  @include mq(sm) {
    padding: 0 80px 100px 0;
  }
}

input,
textarea {
  background: transparent;
  border: 0;
  width: 100%;
  padding: 20px;

  &:focus {
    outline: none;
  }
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  border: 0px;
  -webkit-text-fill-color: $color-white;
  -webkit-box-shadow: 0 0 0px 1000px #000 inset;
  transition: background-color 5000s ease-in-out 0s;
}

.form {
  display: flex;
  flex-flow: row wrap;
}

.inputContainer {
  position: relative;
  margin-bottom: 40px;
  width: 100%;
  flex: 0 0 auto;

  @include mq(sm) {
    width: 50%;
  }

  p {
    position: absolute;
    top: 100%;
    color: $color-blue;
    font-size: font-size(s);
    padding-top: 5px;
  }

  &.focus {
    &::after {
      transform: scale(1, 1);
    }
  }

  &.fullWidth {
    width: 100%;
  }

  &::after,
  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: $color-gray-brown;
    transition: all 0.3s ease-out;
  }

  &::after {
    z-index: 1;
    background: white;
    transform-origin: 0;
    transform: scale(0, 1);
  }

  &.privacy {
    &::before,
    &::after {
      content: none;
    }

    input {
      @include visually-hidden;

      &:checked + .fakeInput {
        background: $color-gray-brown;
      }
    }

    div {
      display: inline-block;
    }

    label {
      cursor: pointer;
      font-size: font-size(s);

      color: $color-gray-brown;

      .fakeInput {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin: 0 4px 0 0;
        
        border: 1px solid $color-gray-brown;
        vertical-align: baseline;
      }
    }
  }
}

.submitContainer {
  width: 100%;
  display: flex;

  button {
    width: 100%;
  }

  @include mq(sm) {
    justify-content: flex-end;

    button {
      width: auto;
    }
  }
}

input
textarea {
  @include placeholder() {
    color: $color-gray-brown;
  }
}

.thxMsg {
  top: 60px;
  position: absolute;

  @include mq(sm) {
    top: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContactForm.vue